import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CancellationofserviceComponent } from './cancellationofservice.component';

const routes: Routes = [
    {
        path: '',
        component: CancellationofserviceComponent,
        data: {
            title: 'Cancellation of Service Component'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CancellationofserviceRoutingModule { }
